//this is the only one that goes out
//email tempalte is connected
//contact-us.tsx is connected

//sendemail in netlify/functions is NOT CONNECTED
//problem is not here but the netlify functions
import getEmailTemplate from './util/emailTemplateFormat';

const sendEmail = async (data) => {
  const payload = {
    emailTo: data.emailTo,
    emailFrom: 'noreply@koppersinc.com',
    emailSubject: 'Inquiry via koppers.com',
    emailTemplate: getEmailTemplate(data),
  };
  try {
    //this is the correct fetch url
    const response = await fetch('/.netlify/functions/sendemail', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify(payload),
    });
    if (!response.ok) return {success: false, message: 'Response Error'};
  } catch (e) {
    return {success: false, message: 'Exception'};
  }
  return {success: true, message: ''};
};

export default sendEmail;
